import { serialize, serializedConstraints } from 'components/widgets/ActivitiesGraph/ActivitiesGraph.utils';

export const useActivitiesGraphLogic = ({ api, ui }) => {
    const dataset = serialize(api.activitiesGraph.data?.tasks).filter((item) => {
        return ui.state.showMilestones ? item : !item.milestone;
    });

    const constraints = serializedConstraints(api.activitiesGraph.data?.tasksConstraints, dataset);
    return { logic: { dataset, constraints } };
};
